import { useRef } from 'react'
import { checkRapidClicks } from '../utils/devData'

export type Tab = 'input' | 'results' | 'charts'

type TabBarProps = {
  activeTab: Tab
  onTabChange: (tab: Tab) => void
  onDevMode?: () => void
}

export function TabBar({ activeTab, onTabChange, onDevMode }: TabBarProps) {
  const clickTimestamps = useRef<number[]>([])

  const handleInputClick = () => {
    onTabChange('input')

    if (!onDevMode) return

    if (checkRapidClicks(clickTimestamps.current)) {
      onDevMode()
    }
  }

  return (
    <div className="flex border-b border-black/10">
      <button
        onClick={handleInputClick}
        className={`px-6 py-3 font-medium transition-colors ${
          activeTab === 'input'
            ? 'border-b-2 border-black text-black'
            : 'text-black/50 hover:text-black'
        }`}
      >
        Input
      </button>
      <button
        onClick={() => onTabChange('results')}
        className={`px-6 py-3 font-medium transition-colors ${
          activeTab === 'results'
            ? 'border-b-2 border-black text-black'
            : 'text-black/50 hover:text-black'
        }`}
      >
        Results
      </button>
      <button
        onClick={() => onTabChange('charts')}
        className={`px-6 py-3 font-medium transition-colors ${
          activeTab === 'charts'
            ? 'border-b-2 border-black text-black'
            : 'text-black/50 hover:text-black'
        }`}
      >
        Charts
      </button>
    </div>
  )
}
